module.exports = __webpack_public_path__ + "img/liz_coulter.2efa870c.jpg";